export default __webpack_public_path__ + "images/logo-bw.svg?266aece627d13ffa6684937b8413f5f1";